// workspaces#show — the whole page body is the React workspace app.
import { registerPage } from "../first"
import { mountWorkspaceApp } from "../workspace_app"

export const WorkspacesShowPage = {
  onDomReady(): void {
    mountWorkspaceApp()
  },
}

registerPage("WorkspacesShowPage", WorkspacesShowPage)
